export enum EDynamisationTypes {
  D0 = 'D0', D1 = 'D1', D2 = 'D2', D3 = 'D3', D4 = 'D4', NONE = ''
}
